import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/app/product/[slug]/@info/components/ImageSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/Notification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/OptimizedImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/product-page/NavigationSelect.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["H2","H6","Paragraph","H4","H3","Small","H5"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/Typography.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/apps/web/src/components/ViewMore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/yangyang/Repos/boom/node_modules/@mui/icons-material/Star.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/yangyang/Repos/boom/node_modules/@mui/icons-material/StarBorder.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/yangyang/Repos/boom/node_modules/@mui/icons-material/StarHalf.js");
;
import(/* webpackMode: "eager" */ "/Users/yangyang/Repos/boom/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/Users/yangyang/Repos/boom/node_modules/@mui/material/Chip/index.js");
;
import(/* webpackMode: "eager" */ "/Users/yangyang/Repos/boom/node_modules/@mui/material/Grid/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yangyang/Repos/boom/node_modules/@mui/material/Stack/index.js");
;
import(/* webpackMode: "eager" */ "/Users/yangyang/Repos/boom/node_modules/@mui/material/Tooltip/index.js");
;
import(/* webpackMode: "eager" */ "/Users/yangyang/Repos/boom/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/yangyang/Repos/boom/node_modules/next/dist/client/link.js");
